import { Button } from 'components/buttons/Button';
import { SearchBox } from 'components/filters/SearchBox';
import { DashboardLayout } from 'components/layout/DashboardLayout';
import { GeneralTable } from 'components/tables/GeneralTable';
import { useCustomSelector } from 'hooks';
import React, { useEffect, useRef, useState } from 'react';
import { useTableActions } from './hooks';
import { useTableColumns } from './hooks/useTableColumns';
import { useTableData } from './hooks/useTableData';

import ic_activate_all from "assets/images/ic_reactivate_all.svg";
import "assets/scss/distributorPortal/modules/comActivationRequest.scss";
import { convertArrayToDropdownArrayFormat, isArrayNotEmpty, isObjectNotEmpty } from 'functions';
import { Toaster } from 'components/notification/Toaster';
import FiltersWrapper from 'components/filters/FiltersWrapper';
import { Dropdown } from 'components/filters/Dropdown';
import { FormInput_text } from 'components/form/formInput/FormInput_text';

function ComActivationRequest() {
    const [currentTabId, setCurrentTabId] = useState("comList");

    const requestType = useRef("COM Reactivation");
    const [isSearchboxReset, setIsSearchboxReset] = useState();
    useEffect(() => {
        if (isSearchboxReset) setIsSearchboxReset(false);
    }, [isSearchboxReset])
    
    let tabsDetails = [
        {
            id: "comList",
            text: "Suspended COM List",
            filters: {
                suspended: true,
                isTrial: undefined,
                requestNameNotPending: "ReactiveComId",
            }
        },
        {
            id: "pending",
            text: "Pending",
            filters: {
                requestStatus: "Pending"
            }
        },
        {
            id: "activated",
            text: "Accepted",
            filters: {
                requestStatus: "Done"
            }
        },
        {
            id: "rejected",
            text: "Rejected",
            filters: {
                requestStatus: "Rejected"
            }
        },
    ];

    const {
        userPermissions
    } = useCustomSelector("distributorPortal_userManagementReducers");

    const {
        getData,
        data, 
        isDataLoading,
        totalRecords
    } = useTableData(currentTabId);

    const {
        selectedCOMs, setSelectedCOMs,

        setIsSingleRequest,
        setSingleCOMDetail,
        
        requestingSingleRowPos,
        isRequestSuccessful,

        requestModal, setIsModalVisible
    } = useTableActions({ requestType });

    const columns = useTableColumns({
        requestingSingleRowPos,
        setIsModalVisible, setIsSingleRequest,
        setSingleCOMDetail,
        currentTabId, 
        requestType
    });

    return (
        <DashboardLayout
            headerTitle={"COM Activation"}

            bodyClassName={"com-activation-request"}
            body={(
                <>
                    {requestModal}
                    
                    <GeneralTable
                        className={"com-activation-request__table"}
                        columns={columns}
                        data={userPermissions?.Dealer_ComInfo_View? data:[]}

                        isTableRefreshRequired={isRequestSuccessful}

                        getTableData={getData}

                        onRowSelectionChange={setSelectedCOMs}

                        outerTableHeader={(outerTableHeader_props) => {
                            const { 
                                filterOptions, setFilterOptions
                            } = outerTableHeader_props;

                            return (
                                <div className={"table__headers"}>
                                    {/* Top Section */}
                                    <div className={"headers__top-section d-flex justify-content-between align-items-center"}>
                                        {/* Title */}
                                        <div className={"top-section__title tableHeaderTitle"}>
                                            List
                                        </div>

                                        {/* Request All */}
                                        {currentTabId === "comList" && (
                                            <Button
                                                className={"top-section__request-all  d-flex align-items-center"}
                                                isDisabled={!(userPermissions?.Dealer_ComInfo_Update)}
                                                handleOnClick={() => {
                                                    if (isArrayNotEmpty(selectedCOMs)) {
                                                        setIsModalVisible(true);
                                                        setIsSingleRequest(false);
                                                    }
                                                    else {
                                                        Toaster({
                                                            type: "info",
                                                            msg: "Please select at least 1 COM"
                                                        })
                                                    }
                                                }}
                                                isSpinnerColorPrimary isDecoration_primaryTransparent
                                            >
                                                <>
                                                    <img
                                                        className={"request-all__icon"}
                                                        src={ic_activate_all}
                                                    />

                                                    <span className={"request-all__text tableHeaderButtonText "}>{requestType.current == "COM Reactivation"? "Reactivate":"Activate"}</span>
                                                </>
                                            </Button>
                                        )}
                                    </div>

                                    {/* Bottom Section */}
                                    <div className={"headers__bottom-section d-flex"}>
                                        {/* Request Type */}
                                        {currentTabId === "comList" && (
                                            <Dropdown
                                                className={"bottom-section__request-type"}
                                                label={"Request Type"}

                                                isUpdatingLabel_fromParent
                                                selectedValueLabel_default={"COM Reactivation"}

                                                selectedValueClassName={"request-type__input"}
                                                onChange={(value) => {
                                                    requestType.current = value;

                                                    let filterOptions_validated = isObjectNotEmpty(filterOptions)? filterOptions:{};
                                                    
                                                    setFilterOptions({
                                                        ...filterOptions_validated,
                                                        ...((value == "COM Reactivation")? { suspended: true, isTrial: undefined, requestNameNotPending: "ReactiveComId" }:{}),
                                                        ...((value == "Trial to Active")? { isTrial: true, suspended: undefined, requestNameNotPending: "TrialToBillableCom" }:{}),
                                                    })
                                                }}
                                                options={convertArrayToDropdownArrayFormat([
                                                    "COM Reactivation",
                                                    "Trial to Active"
                                                ])}
                                            />
                                        )}

                                        {/* Company ID */}
                                        <FormInput_text
                                            inputLabel={"COM ID"}

                                            className={"bottom-section__com-id"}
                                            propagateValueChange={(stateName, value) => {
                                                let filterOptions_validated = isObjectNotEmpty(filterOptions)? filterOptions:{};
                                                
                                                setFilterOptions({
                                                    ...filterOptions_validated,
                                                    comId: value
                                                })
                                            }}

                                            isMarginBtmOptional isInputDigitOnly
                                            isInputOptional
                                        />
                                    </div>
                                </div>
                            );
                        }}

                        defaultFilter={{
                            suspended: true,
                            showOnlyReactivationNotPending: true
                        }}
                        tabsDetails={tabsDetails}
                        onTabIdChange={(tabId) => {
                            setCurrentTabId(tabId);
                            setIsSearchboxReset(true);
                        }}
                        defaultTabId={currentTabId}
                        isTabRequired
                        
                        isTableDataLoading={isDataLoading}

                        isUsingPagination
                        totalRecords={totalRecords}

                        isColumnResizeable
                        isTableOddRowsDarken
                        isCheckboxRequired={userPermissions?.Dealer_ComInfo_Update && currentTabId === "comList"}
                        isCheckboxColumnFirst
                    />
                </>
            )}
        />
    );
}

export default ComActivationRequest;